function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 2v12l-4-3V5l4-3zm5.657.343A7.975 7.975 0 0116 8a7.975 7.975 0 01-2.342 5.656l-.708-.706A6.978 6.978 0 0015 8a6.978 6.978 0 00-2.05-4.95l.707-.707zm-1.415 1.413A5.981 5.981 0 0114 8a5.981 5.981 0 01-1.757 4.243l-.707-.707A4.984 4.984 0 0013 8c0-1.38-.56-2.63-1.464-3.536l.706-.708zM3 11H1a1 1 0 01-1-1V6a1 1 0 011-1h2v6zm7.828-5.828A3.987 3.987 0 0112 8a3.987 3.987 0 01-1.172 2.828l-.707-.707A2.99 2.99 0 0011 8a2.99 2.99 0 00-.879-2.121l.707-.707z",
  fill: "currentColor"
});

var SvgVolumeOn = function SvgVolumeOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVolumeOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/VolumeOn.1c34c2dd.svg";
export { ForwardRef as ReactComponent };